/* eslint-disable prettier/prettier */
import 'core-js'
import React from 'react'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import 'react-phone-number-input/style.css'
import { Provider } from 'react-redux'
import App from './App'
import * as serviceWorker from './serviceWorker'
// import store from './store'
import store from "./store/index"

ReactDOM.render(
 
  <Provider store={store}>
    <App />
  </Provider>
 ,
  document.getElementById('root'),
)
serviceWorker.unregister()
